import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import useLenisSmoothScroll from "@/lib/useLenis";

function App() {
  useLenisSmoothScroll();
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: "6px",
            border: "1px solid #0E2A1A",
            background: "#FFFFFF",
            color: "#111613",
            fontFamily: "Inter, sans-serif",
            letterSpacing: "0.01em",
          },
        }}
      />
    </div>
  );
}

export default App;
